import React, { useState, useEffect } from 'react'
import { X, Download, FileText } from 'lucide-react'
import Navbar from '../component/includes/navbar'
import Footer from '../component/includes/footer'
import { educationService } from '../services/Education'
import { ServiceEducationContent } from '../services/Education'

function InternshipRegistration() {
  const [requirements, setRequirements] = useState<ServiceEducationContent[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [selectedFile, setSelectedFile] = useState<string | null>(null)

  useEffect(() => {
    const fetchRequirements = async () => {
      try {
        const content = await educationService.getEducationalContent()
        if (content.length === 0) {
          setError('Pendaftaran belum ada')
        } else {
          setRequirements(content)
        }
      } catch (err) {
        setError('Failed to fetch internship requirements')
      } finally {
        setLoading(false)
      }
    }

    fetchRequirements()
  }, [])

  const handleFileDownload = (file?: string | File) => {
    if (!file) {
      alert('No file available for download')
      return
    }

    // Construct the full file URL
    const fileUrl = `${process.env.REACT_APP_API_URL}/${file}`

    // Create a temporary anchor element to trigger download
    const link = document.createElement('a')
    link.href = fileUrl
    link.setAttribute('download', typeof file === 'string' ? file : file.name)
    document.body.appendChild(link)
    link.click()
    
    // Clean up
    document.body.removeChild(link)
  }

  const handleShowFile = (file?: string | File) => {
    if (!file) {
      alert('No file available to show')
      return
    }

    // Construct the full file URL
    const fileUrl = `${process.env.REACT_APP_API_URL}/${file}`
    setSelectedFile(fileUrl)
  }

  const closeFileViewer = () => {
    setSelectedFile(null)
  }

  // File Viewer Modal Component
  const FileViewerModal = () => {
    if (!selectedFile) return null

    // Determine file type
    const fileExtension = selectedFile.split('.').pop()?.toLowerCase()
    const isPDF = fileExtension === 'pdf'
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension || '')

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] p-6">
          {/* Close Button */}
          <button 
            onClick={closeFileViewer}
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
          >
            <X size={24} />
          </button>

          {/* File Viewer Content */}
          <div className="w-full h-full flex flex-col items-center">
            {isPDF && (
              <iframe 
                src={selectedFile} 
                className="w-full h-[70vh]" 
                title="PDF Viewer"
              />
            )}

            {isImage && (
              <img 
                src={selectedFile} 
                alt="Uploaded file" 
                className="max-w-full max-h-[70vh] object-contain" 
              />
            )}

            {!isPDF && !isImage && (
              <div className="flex flex-col items-center justify-center h-full">
                <FileText size={64} className="text-gray-400 mb-4" />
                <p className="text-gray-600">Pratinjau file tidak tersedia</p>
              </div>
            )}

            {/* Download Button */}
           
          </div>
        </div>
      </div>
    )
  }

  if (loading) {
    return (
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow flex items-center justify-center">
          <p className="text-xl">Memuat informasi edukasi & magang WKJ...</p>
        </main>
        <Footer />
      </div>
    )
  }


  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow mt-10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 mt-20">
          <h1 className="text-3xl font-bold mb-8">Pendaftaran Edukasi & Magang Wisata Kesehatan Jamu (WKJ)</h1>

          {requirements.length === 0 ? (
            <p className="text-gray-600 ">Pendaftaran belum ada saat ini.</p>
          ) : (
            <div className="space-y-8">
              {requirements.map((requirement) => (
                <div 
                  key={requirement.id} 
                  className="bg-white shadow-md rounded-lg p-6"
                >
                  <h2 className="text-2xl font-semibold mb-4">{requirement.title}</h2>
                  <p className="text-gray-700 mb-4">{requirement.description}</p>

                  {requirement.file && (
                    <div className="flex space-x-4 mt-4">
                      <button 
                        onClick={() => handleShowFile(requirement.file)}
                        className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded transition duration-300 inline-flex items-center"
                      >
                        <FileText size={20} className="mr-2" />
                        Lihat Dokumen
                      </button>
                      <button 
                        onClick={() => handleFileDownload(requirement.file)}
                        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded transition duration-300 inline-flex items-center"
                      >
                        <Download size={20} className="mr-2" />
                        Unduh Dokumen
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
      
      {/* File Viewer Modal */}
      <FileViewerModal />
    </div>
  )
}

export default InternshipRegistration